



















import {
  Component,
  Prop,
  Vue,
  Watch,
} from 'vue-property-decorator';
import {
  Action,
  Getter,
} from 'vuex-class';

import SystemMessage from '@/components/SystemMessages/Message.vue';
import {
  SystemMessage as SystemMessageType,
} from '@/components/SystemMessages/types';


interface TimeoutHandlerObject {
  [key: number]: number | undefined;
}

@Component({
  name: 'system-messages-wrapper',
  components: {
    SystemMessage,
  },
})
export default class SystemMessagesWrapper extends Vue {
  @Prop({ type: Number, default: 4500 })
  removeDelay!: number;

  @Action('systemMessages/remove')
  private readonly removeMessage!: (id: number) => void;

  @Getter('systemMessages/list')
  private readonly messagesList!: SystemMessageType[];

  private timeouts: TimeoutHandlerObject = {};

  private get newestMessage(): SystemMessageType | undefined {
    if (this.messagesList.length) {
      return this.messagesList[this.messagesList.length - 1];
    }

    return undefined;
  }

  @Watch('messagesList')
  private onMessagesListUpdate(): void {
    const { id: newMessageId } = this.newestMessage || {};

    if (newMessageId) {
      this.setMessageRemoveTimeout(newMessageId);
    }
  }

  private onMouseEnter(id: number): void {
    this.unsetMessageRemoveTimeout(id);
  }

  private onMouseLeave(id: number): void {
    this.setMessageRemoveTimeout(id);
  }

  private deleteMessage(id: number): void {
    this.removeMessage(id);
    this.unsetMessageRemoveTimeout(id);
  }

  private setMessageRemoveTimeout(id: number): void {
    const messageTimeout = this.timeouts[id];

    if (!messageTimeout) {
      this.timeouts[id] = setTimeout(() => {
        this.deleteMessage(id);
      }, this.removeDelay);
    }
  }

  private unsetMessageRemoveTimeout(id: number): void {
    clearTimeout(this.timeouts[id]);
    delete this.timeouts[id];
  }

  private reloadPage(): void {
    location.reload();
  }

  private beforeDestroy(): void {
    Object.values(this.timeouts).forEach((id: number) => clearTimeout(this.timeouts[id]));
    this.timeouts = {};
  }
}
